/**
 * Discount/promo codes are blocked only while an item is being sold as a limited-time MC promo —
 * the backend sets `hasSpecialMcPromo` on those items. When MC pricing is shown as standard pricing
 * the marker is absent, so discount codes are allowed.
 *
 * @param {Array<{ hasSpecialMcPromo?: boolean }>} [products]
 * @returns {boolean} true if any product is a limited-time MC promo (discount codes should be blocked)
 */
export const hasActiveMcPromo = (products = []) => products.some((product) => product?.hasSpecialMcPromo === true);
